module.exports = __webpack_public_path__ + "img/BN.1d197411.svg";